import React from 'react';
import { Popover } from 'antd';
import { X } from 'react-feather';
import GradientPicker from './GradientPicker';
// import './ColorPicker.scss';

const ColorWrapper = ({
  children,
  value,
  onChange,
  title,
  visible,
  setVisible,
}) => {
  const renderContent = () => {
    return (
      <div className="picker-wrapper">
        <div className="picker-wrapper__header">
          <span className="picker-wrapper__header--title">{title}</span>
          <X
            className="picker-wrapper__header--close"
            size={16}
            onClick={() => setVisible(false)}
          />
        </div>
        <GradientPicker value={value} onChange={onChange} />
      </div>
    );
  };

  return (
    <Popover
      open={visible}
      onOpenChange={setVisible}
      trigger={['click']}
      content={renderContent()}
      destroyTooltipOnHide
      overlayClassName="color-picker"
    >
      {children}
    </Popover>
  );
};
export default ColorWrapper;
